import { DESKTOP_MAX_WIDTH, DESKTOP_MIN_HEIGHT, MOBILE_WIDTH, MOBILE_MIN_HEIGHT, DESKTOP_MIN_WIDTH } from 'crazyEditor/core/constants/editorConstants';

export default {
  draggable: false,
  hoverable: false,
  resizable: false,
  fullWidth: false,
  selectable: false,
  limitPageWidth: {
    minWidth: DESKTOP_MIN_WIDTH,
    maxWidth: DESKTOP_MAX_WIDTH,
  },
  minWidth: 0,
  maxWidth: 5000, // infinite
  minHeight: DESKTOP_MIN_HEIGHT,
  aspectRatioDisabled: true,
  mobileProps: {
    fullWidth: true,
    minWidth: MOBILE_WIDTH,
    maxWidth: MOBILE_WIDTH,
  },
};
